import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
/**
 * How many discussions one page of the block holds.
 *
 * A short page on purpose: the block is a teaser at the bottom of the browse
 * page, and the reader who wants the rest presses the list's own "load more"
 * button.
 */
const PAGE_SIZE = 5;

/**
 * The state of the block, shared by every instance of the component.
 *
 * `DiscussionListState` registers a listener on a global event emitter when
 * it is built, and never takes it off again — so building a new one on every
 * visit to the page would leak a listener on every visit. One state for the
 * whole session instead.
 */
let relatedState = null;

/**
 * The state, built once.
 *
 * The filter asks the API for the discussions that use a hot topic; the hot
 * topics themselves are worked out by the back end, the same way the hot area
 * works them out, so the two can never disagree about what "hot" means.
 */
function relatedDiscussions() {
  if (!relatedState) {
    relatedState = new DiscussionListState({
      filter: {
        hotTopic: '1'
      }
    });
    relatedState.pageSize = PAGE_SIZE;
  }
  return relatedState;
}

/**
 * The related articles — the discussions that use a hot topic.
 *
 * The topic list above answers "which topics are hot"; this one answers
 * "which discussions are people actually writing in them", which the list
 * cannot answer on its own.
 *
 * The list is Flarum's own, the same component the /all page shows, so it
 * brings Flarum's discussion visibility scoping, its pagination, its "load
 * more" button and its styling with it. Nothing here is re-implemented: the
 * block is a heading and a native discussion list.
 */
export default class RelatedArticles extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.state = relatedDiscussions();

    /**
     * A reload rather than a first load: the state is shared, so the block
     * has to show what is on the server now and not what was there the last
     * time the page was opened. The failure of the request is already shown
     * by the request itself.
     */
    this.state.refresh().catch(() => {});
  }
  view(vnode) {
    /**
     * Nothing to show, nothing to say: an empty block would only take up
     * room on the page.
     *
     * The native list draws a placeholder of its own when it has nothing,
     * and that placeholder is not wanted here — the whole block, heading
     * included, goes away.
     */
    if (!this.state.isInitialLoading() && this.state.isEmpty()) return null;
    return m("div", {
      className: "TopicsPage-related"
    }, m("h2", {
      className: "TopicsPage-relatedTitle"
    }, m(Icon, {
      name: "fas fa-fire"
    }), " ", app.translator.trans('ziiven-topics.forum.browse.related_title')), m(DiscussionList, {
      state: this.state
    }));
  }
}
flarum.reg.add('ziiven-topics', 'forum/components/RelatedArticles', RelatedArticles);